import React from "react";
import { dateRange, initials } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function ArcHeaderTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl shadow-2xl text-[13px] leading-relaxed overflow-hidden" data-testid="resume-live-preview">
      <div className="flex flex-col items-center pt-7 pb-9 px-6 rounded-b-[60px] text-center" style={{ backgroundColor: accent }}>
        <div className="w-14 h-14 rounded-full bg-white flex items-center justify-center font-bold text-lg mb-2" style={{ color: accent }}>{initials(draft.full_name)}</div>
        <h1 className="text-xl font-bold text-white">{draft.full_name || "Your Name"}</h1>
        {draft.target_role && <p className="text-white/80 text-[12px] mt-0.5">{draft.target_role}</p>}
        <p className="text-white/70 text-[11px] mt-1">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join("  •  ")}</p>
      </div>
      <div className="p-6 -mt-2">
        {draft.summary && <p className="text-slate-700 mb-4">{draft.summary}</p>}
        {draft.experience.length > 0 && (
          <div className="mb-4">
            <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Experience</h2>
            {draft.experience.map((e, i) => (
              <div key={i} className="mb-2.5">
                <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
                <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
              </div>
            ))}
          </div>
        )}
        {draft.education.length > 0 && (
          <div className="mb-4">
            <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Education</h2>
            {draft.education.map((ed, i) => <p key={i} className="text-slate-700">{ed.degree} {ed.field} — {ed.school}</p>)}
          </div>
        )}
        {draft.skills.length > 0 && (
          <div className="mb-4">
            <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Skills</h2>
            <p className="text-slate-700">{draft.skills.join(", ")}</p>
          </div>
        )}
        <ExtraResumeSections draft={draft} accent={accent} />
      </div>
    </div>
  );
}
